import axios from './axios'

function service(endpoint) {

    function syncRoles (id, data) {
        return axios.post(`${endpoint}/${id}/roles`, data).then(response => {
            return response.data;
        }).catch(e => {
            throw e
        });
    }

    function fetchRoles(id) {
        return axios.get(`${endpoint}/role-tree/${id}`).then(response => {
            return response.data;
        }).catch(e => {
            throw e
        });
    }

    function saveRoles(id, data = {}) {
        return axios.post(`${endpoint}/role-tree/${id}`, data).then(response => {
            return response.data;
        }).catch(e => {
            throw e
        });
    }

    return {
        syncRoles,
        fetchRoles,
        saveRoles
    }
}

export default service
